import { render, staticRenderFns } from "./MSOGroupEditor.vue?vue&type=template&id=0d129675&"
import script from "./MSOGroupEditor.vue?vue&type=script&lang=js&"
export * from "./MSOGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports